import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Sur place',
      [RoomServiceLocationType.TableService]: 'Sur place',
      both: 'Sur place',
    },
    [ORDER_METHODS.PICKUP]: 'À emporter',
    [ORDER_METHODS.DELIVERY]: 'Livraison',
  },
};
